import {alpha, Box, Typography, useTheme} from '@mui/material';
import {useTranslate} from 'hooks';

type DepositUpcomingDateCardProps = {
  upcomingDate: string;
};

export const DepositUpcomingDateCard: React.FC<
  DepositUpcomingDateCardProps
> = ({upcomingDate}) => {
  const translate = useTranslate();
  const theme = useTheme();

  if (!upcomingDate) {
    return null;
  }

  return (
    <Box
      sx={{
        color: theme.palette.primary.dark,
        backgroundColor: alpha(theme.palette.primary.light, 0.12),
        display: 'flex',
        gap: 1,
        borderRadius: '10px',
        py: theme.spacing(1),
        px: theme.spacing(2),
        mb: theme.spacing(2),
      }}>
      <Typography variant={'body1'}>
        {translate('savings.deposit.monthly.upcoming')}
      </Typography>
      <Typography variant={'body2'} sx={{fontWeight: 700}}>
        {upcomingDate}
      </Typography>
    </Box>
  );
};
